import { makeAutoObservable } from 'mobx';
import { AppConfig } from '@/config/types';
import { BFFGet } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';

type SystemSymbolConfig = {
  androidNativeSymbol: string[];
  androidStartSystemSymbol: string[];
  androidSystemSymbol: string[];
  harmonySystemSymbol: string[];
  iosSystemSymbol: string[];
  androidContainSystemSymbol: string[];
};


export class AppStore {
  systemSymbolConfig?: SystemSymbolConfig = undefined;

  appConfig?: AppConfig = undefined;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setAppConfig(appConfig: AppConfig) {
    this.appConfig = appConfig;
  }

  public async loadSymbols() {
    if (this.systemSymbolConfig !== undefined) {
      return this.systemSymbolConfig;
    }

    const res = await BFFGet(`/${API_PREFIX}/api/config/system-symbol`);
    const systemConfig = res.data || {};
    this.systemSymbolConfig = {
      androidNativeSymbol: systemConfig.android_native_key || [],
      androidStartSystemSymbol: systemConfig.android_sys_key?.split(';') ?? [],
      androidSystemSymbol: systemConfig.android_sys_symbols || [],
      harmonySystemSymbol: systemConfig.harmony_system_key || [],
      iosSystemSymbol: systemConfig.ios_sys_Key || [],
      // android包含
      androidContainSystemSymbol: systemConfig?.android_sys_contain_key || [],
    };
    return this.systemSymbolConfig;
  }
}
